(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-instagram"]) return;
  try {
    
  var slider = tns({
    container: '.instagram-crousel',
    "items": 1,
    "controls": false,
    "mouseDrag": true,
    "swipeAngle": false,
    "speed": 400,
    "edgePadding": 0,
    "responsive": {
      "767": {
        "autoplay": false,
        "items": 1,
        "controls": true,
        "edgePadding": 0
      },
      "768": {
        "items": 4
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
